import React, { ReactElement } from 'react';
import {
  Table, Tbody, Thead, Th, Tr, Td,
} from 'idsk-react-components';
import { Pagination } from 'slovlex-idsk-react-components';
import PodporovatelListPage from '../../../model/podporovatel/PodporovatelListPage';
import mapDate from '../../../function/mapDate';
import './podporovatelTable.scss';

interface Props {
  page: PodporovatelListPage,
  pageNumberFromUrl: number,
}

const PodporovatelTable = ({ page, pageNumberFromUrl } : Props): ReactElement => {
  if (!page) {
    return null;
  }

  if (page.totalElements === 0) {
    return <p className="text-center">Pripomienka nemá žiadneho podporovateľa.</p>;
  }

  if (page.totalElements > 0 && page.podporovatelia.length === 0) {
    return (
      <>
        <p className="text-center">
          Na aktuálnej stránke sa nenachádzajú žiadny podporovatelia.
        </p>
        <Pagination
          number={pageNumberFromUrl}
          size={page.size}
          totalElements={page.totalElements}
        />
      </>
    );
  }

  return (
    <div className="podporovatel-list">
      <div className="podporovatel-table">
        <Table>
          <Thead>
            <Tr>
              <Th className="th-podporovatel">Podporovateľ</Th>
              <Th className="th-organizacia">Organizácia podporovateľa</Th>
              <Th className="th-email">E-mail</Th>
              <Th className="th-datum">Dátum podporenia</Th>
            </Tr>
          </Thead>
          <Tbody>
            {page.podporovatelia.map((podporovatel, i) => (
            // eslint-disable-next-line react/no-array-index-key
              <Tr key={i}>
                <Td>{podporovatel.name}</Td>
                <Td>{podporovatel.organizacia}</Td>
                <Td>{podporovatel.email}</Td>
                <Td>{mapDate(podporovatel.datumPodporenia)}</Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      </div>
      <div className="podporovatel-list__pagination">
        <Pagination
          number={pageNumberFromUrl}
          size={page.size}
          totalElements={page.totalElements}
        />
      </div>
    </div>
  );
};

export default PodporovatelTable;
